document.addEventListener('DOMContentLoaded', function () {
    placeNotes()
    toggleMenu()
    closeMenuOnClick()
    wrapLinesInSpans()
}, false);

function playNote(note) {
    const notes = ["A", "B", "C", "D", "E", "F", "G"]
    const audio = new Audio('/wp-content/themes/nara-estudio/inc/notes/' + notes[note] + '2.mp3')
    audio.play()
}

function placeNotes() {
    const piano = document.getElementsByClassName('is-style-notes')[0];
    if( piano != undefined ) {
        let string = piano.innerHTML
        piano.innerHTML = ""
        let notes = string.split("")
        for(i = 0; i < notes.length; i+=1) {
            let dom = document.createElement('span')
            dom.innerHTML = string[i]
            if(string[i] != " ") {
                dom.classList.add("key")
                dom.onclick = () => playNote(Math.floor(Math.random() * 7))
            }
            piano.appendChild(dom)
        }                 
    }
}


let primaryNav = document.getElementById('primary-nav')
let initScroll = window.scrollY
window.onscroll = () => {
    if( initScroll < window.scrollY ) {
        primaryNav.classList.add("hide-nav")
    }
    initScroll = window.scrollY
}

function toggleMenu() {
    const hamburguerIcon = document.getElementById('hamburguer-icon')
    if( hamburguerIcon != undefined ) {
        hamburguerIcon.onclick = () => {
            primaryNav.classList.remove("hide-nav")
            primaryNav.classList.add("show-nav")
        }
    }
}

function closeMenuOnClick() {
    let navItems = document.getElementsByClassName('menu-item')
    if( navItems != undefined && navItems.length > 0 ) {
        for( const navItem of navItems ) {
            navItem.onclick = () => {
                primaryNav.classList.add("hide-nav")
            }
        }
    }
}

function addClassOnScroll(className, classToAdd) {
    // Obtiene todos los elementos con la clase especificada
    const elements = document.querySelectorAll(`.${className}`);
  
    // Recorre todos los elementos para ver si están visibles en la pantalla
    for (let i = 0; i < elements.length; i++) {
        const elementTop = elements[i].getBoundingClientRect().top;
        const elementHeight = elements[i].getBoundingClientRect().height;
        const windowHeight = window.innerHeight;
        if ( elementTop <= windowHeight - elementHeight / 2 ) {
            // Si el elemento está dentro de la ventana visible, añade la clase deseada
            if( !elements[i].classList.contains(classToAdd) ) {
                elements[i].classList.add(classToAdd)
                animateDelayOnScroll(elements[i])
            }
        }
    }
}

function wrapLinesInSpans() {
    const elements = document.querySelectorAll('.is-style-animate-heading')
    elements.forEach( (element) => {

        const text = element.innerHTML.split('<br>');
        let newHTML = "";
    
        text.forEach( ( line, index ) => {
            newHTML += `<span>${line}</span>`
            if( index < line.length - 1 ) {
                newHTML += '<br>'
            }
        })

        element.innerHTML = newHTML
    })
    
}

function animateDelayOnScroll( element ) {
    const spans = element.querySelectorAll('span');
    let delay = 0;
  
    spans.forEach((span) => {
        span.style.animationDelay = `${delay}s`;
        delay += 0.3;
    })
}

window.addEventListener('scroll', function() {
    addClassOnScroll('is-style-animate-heading', 'animate');
});